import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c622d47"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "contact-card" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "phone" }
const _hoisted_5 = { class: "d-flex flex-wrap justify-start py-2 with-gap" }
const _hoisted_6 = { class: "d-flex flex-wrap align-center justify-center py-2 with-gap" }
const _hoisted_7 = { class: "d-none d-sm-block" }
const _hoisted_8 = { class: "d-none d-sm-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_CopiedButton = _resolveComponent("CopiedButton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!

  return (_openBlock(), _createBlock(_component_v_expansion_panel, {
    rounded: "0",
    value: $props.id,
    ref: "panel"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panel_title, {
        class: "py-2 pl-0",
        onClick: $options.scrollToContact
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: $options.dummyImage,
            alt: "icon"
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString($props.name), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString($props.phone), 1)
          ])
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_v_expansion_panel_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.infoList, (info) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: info.data
              }, [
                (!!info.data)
                  ? (_openBlock(), _createBlock(_component_CopiedButton, {
                      key: 0,
                      data: info.data,
                      title: info.title,
                      isCopied: $data.copiedInfo === info.data,
                      onCopied: _cache[0] || (_cache[0] = ($event: any) => ($data.copiedInfo = $event))
                    }, null, 8, ["data", "title", "isCopied"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              onClick: $options.callContact,
              text: "",
              variant: "outlined",
              color: "success",
              class: "flex-grow-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-sm-3" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-phone")
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('contacts.list.item.buttons.call')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            ($props.email)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: $options.writeContact,
                  text: "",
                  variant: "outlined",
                  color: "success",
                  class: "flex-grow-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-sm-3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-email")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('contacts.list.item.buttons.write')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('editContact', this.id))),
              icon: "",
              variant: "outlined",
              size: "small",
              color: "blue"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-pencil")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deleteContact', this.id))),
              icon: "",
              variant: "outlined",
              size: "small",
              color: "red"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-delete")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}